import React from 'react';
import { noop } from 'lodash';

export interface IAction {
  toggleAlerts: (p: any) => void;
  deleteAlerts: (p: any) => void;
}

interface AlertContext {
  actions: IAction
}

export default React.createContext<AlertContext>({
  actions: {
    toggleAlerts: noop,
    deleteAlerts: noop,
  },
});
